import { ClipLoader } from 'react-spinners';
import styled from 'styled-components';
import { getStateColor } from "../../utils/getStateColor";
const getBackgroundColor = (theme, variant, color, state) => {
  if (variant === 'filled') {
    if (color === 'primary') {
      return getStateColor(theme?.colors?.primary, state);
    } else if (color === 'secondary') {
      return getStateColor(theme?.colors?.secondaryL1, state);
    } else if (color === 'danger') {
      return getStateColor(theme?.colors?.error, state);
    }
  } else {
    if (color === 'primary') {
      return `${theme?.colors?.primary}${state === 'normal' ? '00' : state === 'hover' ? '15' : '25'}`;
    } else if (color === 'secondary') {
      return `${theme?.colors?.secondaryL2}${state === 'normal' ? '00' : state === 'hover' ? '15' : '25'}`;
    } else if (color === 'danger') {
      return `${theme?.colors?.error}${state === 'normal' ? '00' : state === 'hover' ? '15' : '25'}`;
    }
  }
};
export const ButtonContainer = styled.button`
  align-items: center;

  background-color: ${_ref => {
  let {
    theme,
    color,
    variant
  } = _ref;
  return getBackgroundColor(theme, variant, color, 'normal');
}};

  border: ${_ref2 => {
  let {
    theme,
    color,
    variant
  } = _ref2;
  if (variant === 'outline') {
    if (color === 'primary') {
      return `2px solid ${theme?.colors?.primary}`;
    } else if (color === 'secondary') {
      return `2px solid ${theme?.colors?.secondaryL2}`;
    } else if (color === 'danger') {
      return `2px solid ${theme?.colors?.error}`;
    }
  } else return '2px solid transparent';
}};

  border-radius: 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  width: ${_ref3 => {
  let {
    fullWidth
  } = _ref3;
  return fullWidth ? '100%' : 'auto';
}};

  height: ${_ref4 => {
  let {
    size
  } = _ref4;
  if (size === 'sm') return '48px';else if (size === 'md') return '56px';else if (size === 'lg') return '64px';else return 'auto';
}};

  padding: ${_ref5 => {
  let {
    size
  } = _ref5;
  if (size === 'sm') return '24px';else if (size === 'md') return '28px';else if (size === 'lg') return '36px';else return 'auto';
}};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }

  &:not(:disabled):hover {
    background-color: ${_ref6 => {
  let {
    theme,
    color,
    variant
  } = _ref6;
  return getBackgroundColor(theme, variant, color, 'hover');
}};
  }

  &:not(:disabled):active {
    background-color: ${_ref7 => {
  let {
    theme,
    color,
    variant
  } = _ref7;
  return getBackgroundColor(theme, variant, color, 'pressed');
}};
  }
`;
export const ButtonText = styled.span`
  ${_ref8 => {
  let {
    theme,
    size
  } = _ref8;
  if (size === 'sm') return theme.fonts.titleSM;else if (size === 'md') return theme.fonts.titleSM;else if (size === 'lg') return theme.fonts.titleMD;
}};

  padding: ${_ref9 => {
  let {
    size
  } = _ref9;
  if (size === 'sm') return '8px';else if (size === 'md') return '12px';else if (size === 'lg') return '16px';
}};

  color: ${_ref10 => {
  let {
    color
  } = _ref10;
  return color;
}};

  background-color: transparent;
  user-select: none;

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const StyledClipLoader = styled(ClipLoader).attrs(_ref11 => {
  let {
    theme,
    sizeicon
  } = _ref11;
  return {
    color: theme?.colors?.neutralL5,
    size: sizeicon === 'lg' ? 28 : sizeicon === 'md' ? 24 : 20
  };
})`
  position: absolute;
`;